import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseDetails from 'containers/Base/BaseDetails.js';
import { closeDetails, openDetails, toggleModal } from 'reducers/ui';
import PropTypes from 'prop-types';

import { getDepartmentDetailsTransformed } from '../Selectors/departmentSelectors';
import { actions as departmentActions } from '../Modules/dataGridTable';
import { PAGE_URLS } from 'utils/constants/';
import { nameSpace } from '../Modules/nameSpace';

const DepartmentDetails = ({
  id,
  editable,
  toggleEditMode,
  cancel,
  loading,
}) => {
  //------------------------------Selectors---------------------------------
  const details = useSelector(state => getDepartmentDetailsTransformed(state));
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchDepartmentDetails = useCallback(
    id => dispatch(departmentActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchClearDepartmentDetails = useCallback(
    () => dispatch(departmentActions.setGridRowDetails({})),
    [dispatch],
  );
  const dispatchSetDepartmentID = useCallback(
    id => {
      dispatch(departmentActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const dispatchToggleModal = useCallback(link => dispatch(toggleModal(link)), [
    dispatch,
  ]);
  const dispatchCloseDetails = useCallback(
    url => {
      dispatch(closeDetails(url));
    },
    [dispatch],
  );
  //------------------------------------------------------------------------
  useEffect(() => {
    if (id) {
      dispatchFetchDepartmentDetails(id);
      dispatchOpenDetails(PAGE_URLS.DEPARTMENTS.link);
      dispatchSetDepartmentID(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(nameSpace);
  };
  const onCancel = () => {
    cancel();
    dispatchClearDepartmentDetails();
    dispatchCloseDetails(PAGE_URLS.DEPARTMENTS.link);
    dispatchSetDepartmentID(null);
  };
  return (
    <BaseDetails
      header="Department Details"
      editable={editable}
      details={details}
      cancel={onCancel}
      loading={loading}
      onEdit={onEdit}
    />
  );
};
DepartmentDetails.propTypes = {
  cancel: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};

export default DepartmentDetails;
